// src/routes/index.tsx

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
	loader: () => {
		redirect({
			to: "/home",
			throw: true,
		});
	},
});
